var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCambodia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0108C0 18.7827 0.705188 21.3898 1.94544 23.663L16 25.0543L30.0546 23.663C31.2948 21.3898 32 18.7827 32 16.0108C32 13.2389 31.2948 10.6318 30.0546 8.3586L16 6.96729L1.94544 8.3586C0.705188 10.6318 0 13.2389 0 16.0108H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94543 8.35855H30.0545C27.3409 3.38506 22.0647 0.0107422 16 0.0107422C9.93531 0.0107422 4.65912 3.38506 1.94543 8.35855Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C22.0647 32.0107 27.3409 28.6363 30.0546 23.6628H1.94543C4.65912 28.6363 9.93531 32.0107 16 32.0107Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5656 19.1412V17.0542H20.1744V14.2716L18.7831 12.8803L17.3918 14.2716V11.489L16.0004 10.0977L14.6091 11.489V14.2716L13.2178 12.8803L11.8265 14.2716V17.0542H10.4353V19.1412H9.04395V21.2281H22.9569V19.1412H21.5656Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCambodia);
export default __webpack_public_path__ + "static/media/flag_cambodia.237ce5c62cddd649c22dafbfe56c078e.svg";
export { ForwardRef as ReactComponent };